import {
  Container,
  ItemIcon,
  ItemText,
  ListItemStyled,
  TranScriptContent,
  TranScriptData,
  TranScriptLists,
  TranScriptTitle,
} from "./style";
import { CrystalIcon } from "../../../assets/Icons";
import { TransScriptListItem } from "../../../utils/propTypes";

const ListItem = ({ icon, text }: TransScriptListItem) => (
  <ListItemStyled>
    <ItemIcon>{icon}</ItemIcon>
    <ItemText>{text}</ItemText>
  </ListItemStyled>
);

const TranScriptSection = () => {
  const listItems: TransScriptListItem[] = [
    {
      icon: <CrystalIcon />,
      text: "Add captions to video ads to make them accessible and engaging for all viewers, including those watching without sound.",
    },
    {
      icon: <CrystalIcon />,
      text: "Provide transcripts to reach global audiences with translated subtitles.",
    },
  ];

  return (
    <Container>
      <TranScriptContent>
        <TranScriptData>
          <TranScriptTitle>Save and Generate Transcripts</TranScriptTitle>
          <TranScriptLists>
            {listItems.map((item, index) => (
              <ListItem key={index} icon={item.icon} text={item.text} />
            ))}
          </TranScriptLists>
        </TranScriptData>
      </TranScriptContent>
    </Container>
  );
};

export default TranScriptSection;
